import { FormInModal } from "@/shared/form/form-in-modal";
import { useDocumentsTranslations } from "../shared/utils/use-documents-translations";
import { AddButton } from "@/shared/form/button";
import { SaveCompanyDocumentsForm } from "../features/save-company-documents";
import { ReactNode } from "react";

export function AddCompanyDocument({
  folderId,
  trigger,
}: {
  folderId?: string;
  trigger?: (open: () => void) => ReactNode;
}) {
  const t = useDocumentsTranslations();

  return (
    <FormInModal
      title={t("Add company document")}
      trigger={
        trigger ??
        ((open) => <AddButton onClick={open}>{t("Add document")}</AddButton>)
      }
      form={(close) => (
        <SaveCompanyDocumentsForm
          folderId={folderId}
          disableFolder={!!folderId}
          afterSubmit={close}
        />
      )}
    />
  );
}
